export class StartPollingTransactionSyncStatus {
  static readonly type = '[Transactions] Start Polling Transaction Sync Status';
}

export class StartPollingContactSyncStatus {
  static readonly type = '[Transactions] Start Polling Contacts Sync Status';
}

export class StartPollingCategoriesSyncStatus {
  static readonly type = '[Transactions] Start Polling Categories Sync Status';
}

export class StopPollingAccountingSyncStatus {
  static readonly type = '[Transactions] Stop Polling Transaction Sync Status';
}

export class SetTransactionSyncStatus {
  static readonly type = '[Transactions] Set Transaction Sync Status';
}

export class SetContactsSyncStatus {
  static readonly type = '[Transactions] Set Contacts Sync Status';
}

export class ClearTransactionsState {
  static readonly type = '[Transactions] Clear Transactions State';
}

export class ClearTransactionsSyncStatus {
  static readonly type = '[Transactions] Clear Transactions Status Only';
}

export class ClearCategoriesSyncStatus {
  static readonly type = '[Transactions] Clear Categories Status Only';
}

export class ClearContactsSyncStatus {
  static readonly type = '[Transactions] Clear Contacts Status Only';
}

export class SetTransactionSyncTimeout {
  static readonly type = '[Transactions] TransactionSync Timeout';
}
